import {
  AUTH_STEP_PATHNAME,
  JUSBRASIL_DOMAIN,
  PRODUCTION_HOST,
  PRODUCTION_ORIGIN,
} from '@jusbrasil-web/shared-auth-flows'

export { JUSBRASIL_DOMAIN, PRODUCTION_HOST, PRODUCTION_ORIGIN }

export const LOCAL_DEV_HOST = `local.${JUSBRASIL_DOMAIN}`
export const LOCAL_DEV_ORIGIN = `https://${LOCAL_DEV_HOST}`

export const STAGING_HOST = `staging.${JUSBRASIL_DOMAIN}`
export const STAGING_ORIGIN = `https://${STAGING_HOST}`

// The browser-facing allow-list lives in `@jusbrasil-web/shared-auth-flows`: it is a
// security boundary shared with `scope:landing-pages`, which cannot import this lib.
export {
  ALLOWED_BROWSER_ORIGINS,
  ALLOWED_LOCAL_ORIGIN_PATTERN,
  ALLOWED_STAGING_ORIGIN_PATTERN,
  PRODUCTION_APEX_ORIGIN,
} from '@jusbrasil-web/shared-auth-flows'

export const AUTH_API_TIMEOUT = 30000

export const DEFAULT_ERROR_MESSAGE = 'Ocorreu um erro. Por favor, tente mais tarde.'
export const UNEXPECTED_ERROR_MESSAGE = 'Ocorreu um erro ao processar sua solicitação'

export const BIFROST_API = {
  SIGNUP: {
    BY_EMAIL: '/bifrost/api/account-sign-up-or-in-by-email',
    COMPLETE_WITH_TOKEN: '/bifrost/api/signup/email',
    COMPLETE_WITH_TOKEN_B2B: '/bifrost/api/signup/b2b/email',
    CPF_BASED: '/bifrost/api/signup/cpf',
    VALIDATE_TOKEN: '/internal-api/account-signup',
    OTP_SEND: '/bifrost/api/account-signup-by-email-otp',
    OTP_VALIDATE: '/bifrost/api/account-signup-validate-otp',
  },
  SIGNIN: {
    PASSWORD: '/bifrost/api/login',
  },
  PASSWORD_RECOVERY: '/bifrost/api/recover-password',
  CSRF_TOKEN: '/internal-api/csrf-token',
} as const

export const BASE_PATH_B2B = '/b2b'

export const ROUTES = {
  SIGN_IN: {
    BEGIN: AUTH_STEP_PATHNAME.EMAIL,
    PASSWORD_SIGN_IN: AUTH_STEP_PATHNAME.PASSWORD,
    GOOGLE_SIGN_IN: AUTH_STEP_PATHNAME.GOOGLE_ONLY,
  },
  SIGN_UP: {
    BEGIN: '/cadastro',
    DETAILS: '/cadastro/email',
    VERIFY_APP_EMAIL: '/cadastro/verificar-email-app',
    VERIFY_EMAIL_REQUEST_SENT: AUTH_STEP_PATHNAME.SIGNUP_EMAIL_SENT,
    VERIFY_EMAIL_OTP: '/cadastro/confirmacao-por-codigo',
    CPF_BASED_SIGNUP: '/cadastro/cpf',
    CPF_NOT_VERIFIED: '/cadastro/cpf/erro',
    SIGNUP_ATTEMPTS_ERROR: AUTH_STEP_PATHNAME.RATE_LIMITED,
    POST_CPF_BASED: '/cadastro/api/cpf',
    PHONE_STEP: '/cadastro/telefone',
  },
  PASSWORD_RECOVERY: {
    BEGIN: AUTH_STEP_PATHNAME.RECOVERY,
    RESET: '/resetar-senha',
  },
  SSO: {
    ERROR: '/sso/erro',
  },
  B2B: {
    SIGN_UP: {
      DETAILS: '/cadastro/b2b/email',
      VERIFY_EMAIL_REQUEST_SENT: '/cadastro/b2b/confirmacao-por-email-enviada',
    },
  },
} as const

// Occupation IDs must match Bifrost values for compatibility
// See: bifrost/client/src/components/SignUp/Details.jsx
export const OCCUPATION_IDS = {
  lawyer: '291485',
  undergraduate: '296089',
  bachelor: '293507',
  other: '-1',
} as const

export const HELP_CENTER_URL = 'https://suporte.jusbrasil.com.br/hc/pt-br/requests/new'

export const HELP_CENTER_URL_B2B = 'https://solucoes.jusbrasil.com.br/suporte'

export const JUSID_PLATFORM_WEB_AUTH = 'web-auth'

export const ACCOUNT_LIMIT_EVENTS = {
  VIEWED: 'UserAccount.ErrorAccountLimitExceedViewed',
  CLOSED: 'UserAccount.ErrorAccountLimitExceedClosed',
  CONTACT_SUPPORT_CLICKED: 'UserAccount.ErrorAccountLimitExceedContactSupportClicked',
} as const

export const FORCED_GOOGLE_EVENTS = {
  SCREEN_SEEN: 'UserAccount.ForcedGoogleScreenSeen',
  USE_ANOTHER_ACCOUNT: 'UserAccount.ForcedGoogleUseAnotherAccount',
  ERROR: 'UserAccount.ForcedGoogleError',
} as const

export const MODAL_EVENTS = {
  SEEN: 'UserAccount.ModalSeen',
  CLOSED: 'UserAccount.ModalClosed',
} as const

export const PASSWORD_RESET_EVENTS = {
  SCREEN_SEEN: 'UserAccount.PasswordResetScreenSeen',
  SUCCESSFUL: 'UserAccount.PasswordResetSuccessful',
} as const

export const ID_VALIDATION_EVENTS = {
  FAILED_VIEWED: 'UserAccount.IdValidationFailedViewed',
  FAILED_SUBMITTED: 'UserAccount.IdValidationFailedSubmitted',
} as const

export const SIGNUP_EVENTS = {
  SIGN_UP_FORM_PAGE_SEEN: 'UserAccount.SignUpFormPageSeen',
  BELOW_MINIMUM_AGE_BLOCKED: 'UserAccount.BelowMinimumAgeBlocked',
} as const
